import { Box, Grid } from "@mui/material";
import MenuCard from "./menucard";


const coffeemenus = [
    {
        id: "coffee",
        name: "Coffee Menu",
        thainame: "เมนูกาแฟ",
        desc: "เมนูกาแฟหลากหลายเป็นทางเลือกให้คุณ",
        img: '/assets/images/runway/runwaycoffee/coffeemenus/1.png'
    },
    {
        id: "tea",
        name: "Tea Menu",
        thainame: "เมนูชา",
        desc: "เมนูชาหลากหลายเป็นทางเลือกให้คุณ",
        img: '/assets/images/runway/runwaycoffee/coffeemenus/2.png'
    },
    {
        id: "noncoffee",
        name: "Non-Coffee Menu",
        thainame: "เมนูอื่นๆ",
        desc: "เมนูอื่นๆ ที่มีให้คุณเลือกหลากหลาย",
        img: '/assets/images/runway/runwaycoffee/coffeemenus/3.png'
    }

]

export default function CoffeeMenu() {
    return (
      <Grid container spacing={3}>
        {coffeemenus.map(menu => (<Grid key={menu.id} item xs={12} sm={6} md={3}>
          <MenuCard menu={menu} />
        </Grid>))}
      </Grid>
    );
}